import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { RegistrationFlowStep } from 'src/app/constants/registration-flow.constants';
import { NationalMicrochippingMonthPopupComponent } from 'src/app/modals/national-microchipping-month-popup/national-microchipping-month-popup.component';
import { environment } from 'src/environments/environment';
import { RegistrationFlowService } from '../registration-flow/registration-flow.service';

@Injectable({
  providedIn: 'root'
})
export class NationalMicrochippingMonthPopupService {
  private readonly popupName = 'NationalMicrochippingMonthPopup';
  private readonly popupUrl = `${environment.apiUrl}/api/popup`;

  private popupSeenSuccessSubject = new Subject<void>();
  public popupSeenSuccess$ = this.popupSeenSuccessSubject.asObservable();

  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private registrationFlowService: RegistrationFlowService
  ) { }

  public checkAndShowNationalMicrochippingMonthPopup(petType: string) {
    this.http
      .get<{ isSeen: boolean; name: string }>(`${this.popupUrl}/${this.popupName}`)
      .subscribe({
        next: (response) => {
          if (
            !response.isSeen &&
            this.registrationFlowService.isStepCompleted(RegistrationFlowStep.WelcomeGift)
          ) {
            this.showNationalMicrochippingMonthPopup(petType);
          }
        },
        error: (err) => {
          console.error('Error checking popup status', err);
        }
      })
  }

  private showNationalMicrochippingMonthPopup(petType:string) {
    const modalOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
    };

    const modalRef = this.modalService.open(NationalMicrochippingMonthPopupComponent, modalOptions);
    modalRef.componentInstance.petType = petType;

    modalRef.result
      .then(() => {}) // user submitted
      .catch(() => {}) // user rejected
      .finally(() => {
        this.markPopupAsSeen();
      })
  }

  private markPopupAsSeen(): void {
    const payload = { name: this.popupName };

    this.http.put(this.popupUrl, payload).subscribe({
      next: () => {},
      error: (err) => console.error('Failed to update popup status', err)
    });
  }
}
